import React, { useEffect } from "react";

import BodyText from "core/BodyText";
import CodeRequestViewLink from "../links/CodeRequestViewLink";
import PasswordLoginViewLink from "../links/PasswordLoginViewLink";

import { useLoginFlow } from "../Context";

import { CtaButton, FooterTextStyled, FormInputStyled } from "../styles";

import { loginCodeIsValid } from "../helpers";

const CodeConfirmView = () => {
    const {
        startLoginCodeConfirmation,
        isProcessing,
        loginCode,
        setLoginCode,
    } = useLoginFlow();

    useEffect(() => {
        return () => {
            setLoginCode("");
        };
    }, []);

    return (
        <>
            <FormInputStyled
                labelText="Log In Code"
                value={loginCode}
                onChange={setLoginCode}
                data-testid="login-code-input"
                validation={[
                    {
                        errorMsg: "Please enter a valid login code",
                        isValid: loginCodeIsValid,
                    },
                ]}
            />
            <CtaButton
                onClick={e => {
                    e.preventDefault();
                    startLoginCodeConfirmation();
                }}
                isProcessing={isProcessing}
                isDisabled={!loginCodeIsValid(loginCode)}
            >
                Confirm Log In Code
            </CtaButton>
            <FooterTextStyled>
                <BodyText type="p">
                    Didn't get the code?{" "}
                    <CodeRequestViewLink>Try again</CodeRequestViewLink>.
                </BodyText>
                <BodyText type="p">
                    Can't access your email?{" "}
                    <PasswordLoginViewLink>
                        Log In with password
                    </PasswordLoginViewLink>
                    .
                </BodyText>
            </FooterTextStyled>
        </>
    );
};

export default CodeConfirmView;
